import {useCallback, useEffect, useMemo} from 'react';
import {useDispatch} from 'react-redux';
import {sendPageView} from '../../common/util/tracking';
import {CommentTrackingContext} from '../common';
import CommentModal from '../component/CommentModal';
import useEventComment from '../hook/useEventComment';
import {actions} from '../state/action';
import {ICommentSort} from '../type';

interface IProps {
  eventId: number;
  questCampaignId: number;
  isOpen: boolean;
  bgColor?: string;
  onRequestClose: () => void;
}

export default function EventCommentModal({
  eventId,
  questCampaignId,
  isOpen,
  bgColor,
  onRequestClose,
}: IProps) {
  const dispatch = useDispatch();
  const props = useEventComment(eventId);

  const setSort = useCallback(
    (sort: ICommentSort) => {
      dispatch(actions.setEventCommentSort(sort));
    },
    [dispatch]
  );

  useEffect(() => {
    if (isOpen)
      sendPageView({
        section: 'event_page',
        page: 'event_comments',
        actionName: 'comments',
        customProps: {quest_campaign_id: questCampaignId},
        isSendExtra: true,
      });
  }, [questCampaignId, isOpen]);

  const contextValue = useMemo(
    () => ({
      section: 'event_page',
      page: 'event_comments',
      questCampaignId,
    }),
    [questCampaignId]
  );

  return (
    <CommentTrackingContext.Provider value={contextValue}>
      <CommentModal
        isOpen={isOpen}
        isOnlyDarkMode
        bgColor={bgColor}
        inputVariant="white"
        useSpoiler={false}
        setSort={setSort}
        initialSort="createdDt"
        onRequestClose={onRequestClose}
        {...props}
      />
    </CommentTrackingContext.Provider>
  );
}
